import React, { useContext } from "react"
import { useWatch } from "react-hook-form"

import classNames from "classnames"

import { Counter, CounterProps } from "shared/ui/counter/Counter"
import { InputContext } from "shared/ui/input/Input"

import { TextInputContext } from "../TextInputContext"

export interface TextInputCounterProps extends Partial<CounterProps> {}

export const TextInputCounter = React.memo((props: TextInputCounterProps) => {
  const { name } = useContext(InputContext)

  if (name) {
    return <HookFormCounter {...props} />
  }

  return <CounterBase {...props} />
})

export const HookFormCounter = React.memo((props: TextInputCounterProps) => {
  const { name } = useContext(InputContext)
  const value = useWatch({ name })

  const currentLength = typeof value === "string" ? value.length : 0

  return <CounterBase current={currentLength} {...props} />
})

export const CounterBase = React.memo(
  ({ className, current, max, ...props }: TextInputCounterProps) => {
    const { readonly } = useContext(InputContext)
    const { maxLength } = useContext(TextInputContext)

    if (!maxLength || readonly) return null

    return (
      <Counter
        {...props}
        className={classNames("input__counter", className)}
        current={current ?? length}
        max={max ?? maxLength}
      />
    )
  }
)
